import * as React from "react";
import * as ReactDOM from "react-dom";


interface IProperties
{
    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,
    children?: any,
    isHorizontal?: boolean,
    hasBorderTop?: boolean
}

export class FormGroup extends React.Component<IProperties>
{
    render()
    {
        const className: string[] = ["form-group", (this.props.isHorizontal) ? "form-group--horizontal" : ""]

        if (this.props.hasBorderTop)
            className.push("form-group--border-top");

        return (
            <div
                className={className.join(" ")}
                style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}